import { Route } from "@/types/routes"

export const invitationRoute: Route = {
  isPublic: true,
  shouldRedirect: () => false,
}
